/* Разбор выдачи `GET /teacher-schedule/weeks/{week_id}/lessons` на строки таблицы.

   Сервер отдаёт занятия отдельными записями и не склеивает их: в одной паре у
   преподавателя бывает несколько занятий — разные группы, аудитории, иногда и
   разные дисциплины. Строка таблицы — это одна пара дня, поэтому занятия пары
   собираются здесь.

   Признак пары — дата и номер пары; у индивидуальной работы номера пары нет,
   и она различается по времени начала. Номер пары разбором строки не получаем:
   `pair_number`, `time_begin` и `time_end` приходят отдельными полями.

   Порядок дней, пар и занятий внутри пары задаёт сервер — здесь он только
   сохраняется. */

const pairKey = lesson => (lesson.individual_work || lesson.pair_number == null
  ? `${lesson.lesson_date}|ind|${lesson.time_begin || ''}`
  : `${lesson.lesson_date}|${lesson.pair_number}`)

export const buildWeek = (lessons = []) => {
  const days = []
  const dayByDate = new Map()
  const pairByKey = new Map()

  lessons.forEach(lesson => {
    let day = dayByDate.get(lesson.lesson_date)
    if (!day) {
      day = {
        date: lesson.lesson_date,
        weekdayName: lesson.weekday_name,
        pairs: [],
      }
      dayByDate.set(lesson.lesson_date, day)
      days.push(day)
    }

    const key = pairKey(lesson)
    let pair = pairByKey.get(key)
    if (!pair) {
      pair = {
        key,
        date: lesson.lesson_date,
        weekdayName: lesson.weekday_name,
        pairNumber: lesson.pair_number,
        individual: !!lesson.individual_work || lesson.pair_number == null,
        timeBegin: lesson.time_begin,
        timeEnd: lesson.time_end,
        lessons: [],
      }
      pairByKey.set(key, pair)
      day.pairs.push(pair)
    }
    pair.lessons.push(lesson)
  })

  return days
}

/* Значения пары перечисляются через запятую без повторов; пустые в перечень не
   попадают, поэтому лишних запятых не остаётся. Если значение у всех занятий
   пары одно, оно выводится один раз. */
export const uniqueValues = (lessons, getValue) => {
  const values = []
  lessons.forEach(lesson => {
    const value = getValue(lesson)
    const list = Array.isArray(value) ? value : [value]
    list.forEach(item => {
      const text = item == null ? '' : String(item).trim()
      if (text && !values.includes(text)) values.push(text)
    })
  })
  return values
}

export const joinValues = (lessons, getValue) => uniqueValues(lessons, getValue).join(', ')

// «Номер темы/занятия» — номер темы и номер занятия по теме отдельными полями
export const themeNumber = lesson => {
  const parts = [lesson.theme_number, lesson.lesson_number]
    .filter(part => part !== null && part !== undefined && String(part).trim() !== '')
  return parts.join('/')
}

// Подпись пары: номер пары либо «инд. раб.» у индивидуальной работы
export const pairTitle = pair => (pair.individual ? 'инд. раб.' : `${pair.pairNumber} пара`)

export const pairTime = pair => (pair.timeBegin && pair.timeEnd
  ? `${pair.timeBegin}-${pair.timeEnd}`
  : '')
